import { BaseProvider } from "./base.provider";
import { jsonParser } from "../utilities/parsers";
import { event } from "../utilities/event-listeners";
import { injectScript } from "../utilities/dom-mutations";
export class BetradarProvider extends BaseProvider {
    constructor() {
        super(...arguments);
        this.betradarInstance = null;
    }
    initScript(launchData) {
        const { clientScriptData } = launchData;
        return jsonParser(clientScriptData);
    }
    resizeIframe(e) {
        if (e && e.height) {
            window.dispatchEvent(event({
                detail: { height: parseInt(e.height.replace("px", "")) },
            }));
        }
    }
    showLogin() {
        window.verticalBridge.authenticate();
    }
    invokeMobileLogin(scriptData) {
        const { playerToken } = scriptData;
        this.showLogin();
        this.betradarInstance.setUserToken(playerToken);
    }
    initGameForMobile(scriptData) {
        this.betradarInstance = window.vsmobile.init(`#lobby_game`, {
            sport: scriptData.gameType,
            onLoad: this.invokeMobileLogin(scriptData),
            betsChanged(_vsmInstance, _currentBets, _betsAdded, _betsRemoved, betsChangedReason) {
                if (betsChangedReason === "selectionsConfirmedInBetslip") {
                    // Balance refresh should not be necessary
                    // homePage.RefreshCashBalance();
                }
            },
            showSlip(_vsmInstance, _bets) { },
            loginRequired: this.invokeMobileLogin(scriptData),
            // the 2 lines below should not be removed even though it is 0, other things are affecting it, so we need the 0
            topHeaderHeight: 0,
            bottomFooterHeight: 0,
            enableMenuShortcuts: true,
            referrer: scriptData.virtualReferrer,
        });
    }
    initGame(scriptData) {
        window.pm.bind("rgs-anonymous-place", this.showLogin, "*");
        window.pm.bind("rgs-height-change", this.resizeIframe, "*");
    }
    buildExternalScriptForMobile(externalScript, scriptData) {
        if (externalScript) {
            const script = [
                {
                    hid: "betradarmobilescript",
                    defer: true,
                    src: externalScript.url,
                    callback: () => this.initGameForMobile(scriptData),
                },
            ];
            injectScript(script);
        }
    }
    buildExternalScript(externalScript, scriptData) {
        if (externalScript) {
            const script = [
                {
                    hid: "betradarexternalscript",
                    defer: true,
                    src: `${window.location.protocol}://${window.location.host}${externalScript.url}`,
                    callback: () => this.initGame(scriptData),
                },
            ];
            injectScript(script);
        }
    }
    init() {
        const { externalJsScripts, clientScriptData } = this.launchData;
        const { isMobile } = this.initScript(this.launchData);
        const mobileScript = externalJsScripts.find((s) => s.renderForMobile);
        const desktopScript = externalJsScripts.find((s) => s.renderForNonMobile);
        if (isMobile)
            this.buildExternalScriptForMobile(mobileScript, clientScriptData);
        else
            this.buildExternalScript(desktopScript, clientScriptData);
    }
}
